import {Directive, ElementRef, inject, input, OnInit, Renderer2} from '@angular/core';

@Directive({
    selector: '[appClientInformationRow]'
})
export class ClientInformationRowDirective implements OnInit {

  private readonly renderer = inject(Renderer2);
  private readonly elementRef = inject(ElementRef);

  readonly appClientInformationRow = input<string>('');

  ngOnInit() {
    const element = this.elementRef.nativeElement;
    const rowContent = this.appClientInformationRow();
    if (rowContent) {
      const text = this.renderer.createText(rowContent);
      this.renderer.appendChild(element, text);
    }

    if (rowContent === '(Empty)') {
      this.renderer.addClass(element, 'row__detail-value--empty');
    }
  }
}
